<template>
  <v-app>
    <!-- ------------------------------------------------------------------- -->
    <!-- Appbar -->
    <!-- ------------------------------------------------------------------- -->
    <v-app-bar app clipped-left color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title><router-link :to="{name: 'main'}" class="toolbar-title white--text">Orión Stereo</router-link></v-toolbar-title>
    </v-app-bar>
    <!-- ------------------------------------------------------------------- -->
    <!-- Navigation drawer -->
    <!-- ------------------------------------------------------------------- -->
    <v-navigation-drawer
      fixed
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      class="primary"
      dark
      >
      <v-row justify="center">
        <v-avatar :tile="false" :size="80" class="my-2">
          <img src="../assets/img/orion.png" alt="orion stereo" />
        </v-avatar>
      </v-row>
      <v-layout tag="v-list" column class="primary">
        <v-list dense nav class="primary">
          <template v-for="(link, i) in links">
            <!-- ----------------------------------------------------------- -->
            <!-- Links -->
            <!-- ----------------------------------------------------------- -->
            <v-list-item
              v-if="link.isLink"
              :key="i"
              :href="link.to"
              target="_blank"
              link
              class="primary"
            >
              <v-list-item-icon>
                <v-icon class="secondary--text">{{ link.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- --------------------------------------------------------- -->
            <!-- Routes -->
            <!-- --------------------------------------------------------- -->
            <v-list-item
              v-else
              :key="i"
              :to="link.to"
              link
              class="primary"
            >
              <v-list-item-icon>
                <v-icon class="secondary--text">{{ link.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title  class="white--text">{{ link.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-layout>
    </v-navigation-drawer>
    <!-- ------------------------------------------------------------------- -->
    <!-- Seccion de contenido -->
    <!-- ------------------------------------------------------------------- -->
    <v-content>
      <vue-page-transition name="fade-in-up">
        <router-view/>
      </vue-page-transition>
    </v-content>
    <!-- ------------------------------------------------------------------- -->
    <!-- Footer -->
    <!-- ------------------------------------------------------------------- -->
    <v-footer fixed color="primary" app>
      <v-container fluid class="pa-0">
        <v-card flat tile class="ma-0 primary">
          <v-list-item>
            <v-list-item-action>
              <v-btn
                fab
                color="secondary"
                class="primary--text"
                @click="playPause()"
              >
                <v-icon>{{playingIcon}}</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="headline white--text">Al aire ahora</v-list-item-title>
              <v-list-item-subtitle class="white--text">{{currentPrograma}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <audio id="radio" class="d-none">
            <source src="http://174.142.126.11:9964/;" type="audio/mpeg">
          </audio>
        </v-card>
      </v-container>
    </v-footer>
    <!-- ------------------------------------------------------------------- -->
    <!-- Messenger -->
    <!-- ------------------------------------------------------------------- -->
    <v-btn
      fab
      left
      bottom
      color="teal"
      class="btn--messenger"
      href="https://wa.me/50244764457"
      target="_blank"
    >
      <v-icon class="white--text">fab fa-whatsapp</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getDiaSemana } from '../helpers/time'
import dayjs from 'dayjs'
import links from '../helpers/menu'
const today = dayjs().format('YYYY-MM-DD')
export default {
  data () {
    return {
      currentPrograma: 'Orión Stereo',
      drawer: false,
      playingIcon: 'fas fa-play',
      links,
      programacion: [],
      horario: []
    }
  },
  computed: {
    ...mapGetters(['getPlaying', 'getHorario'])
  },
  methods: {
    ...mapMutations(['setPlaying', 'setHorario']),
    playPause () {
      const radio = document.getElementById('radio')
      if (!this.getPlaying) {
        radio.play()
        this.setPlaying(true)
        this.playingIcon = 'fas fa-stop'
      } else {
        radio.pause()
        this.setPlaying(false)
        this.playingIcon = 'fas fa-play'
      }
    },
    getProgramacion () {
      if (!this.getHorario) {
        this.$http.programas
          .get(`?dia=${getDiaSemana()}`)
          .then(res => res.data)
          .then(res => {
            this.programacion = res
            // this.setTimeGT()
          })
      } else {
        // this.setCurrentPrograma()
        // this.watchPrograma()
      }
    },
    setTimeGT () {
      this.setHorario(this.programacion.map(i => {
        return {
          nombre: i.nombre,
          inicio: dayjs(`${today}T${i.inicio}:00-0600`).unix(),
          fin: dayjs(`${today}T${i.fin}:00-0600`).unix()
        }
      }))
      this.setCurrentPrograma()
      this.watchPrograma()
      // this.getCurrentPrograma()
    },
    setCurrentPrograma () {
      const now = dayjs().unix()
      let nombre = 'Orión Stereo'
      this.getHorario.forEach(i => {
        if (now <= i.fin && now >= i.inicio) {
          nombre = i.nombre
        }
      })
      this.currentPrograma = nombre
    },
    watchPrograma () {
      const self = this
      setInterval(() => {
        self.setCurrentPrograma()
      }, 60000)
    }
  },
  mounted () {
    if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
      this.drawer = true
    }
    this.getProgramacion()
  },
  watch: {
    getPlaying () {
      const radio = document.getElementById('radio')
      if (this.getPlaying) {
        radio.play()
        this.playingIcon = 'fas fa-stop'
      } else {
        radio.pause()
        this.playingIcon = 'fas fa-play'
      }
    }
  }
}
</script>

<style>
.btn--messenger {
  bottom: 0;
  right: 0;
  position: fixed;
  z-index: 10000;
  margin-bottom: 96px;
  margin-right: 16px;
}
.toolbar-title {
  color: white;
  text-decoration: none;
}
</style>
